import { createSvgComponent } from "../../icon/createSvgComponent";
import TruckFill from "@core/__generated__/icon/figma/truck-fill.svg";
export default createSvgComponent(TruckFill);